<template>
    <div class="inline-flex items-center justify-center gap-1">
        <hts-icons
            v-if="color === 'red'"
            svg="warning-sign"
            :size="size"
            :color="color" />
        <hts-icons
            v-if="hasWaiting"
            svg="hourglass"
            :size="size"
            fill-color="orange" />
        <div
            v-if="hasAlert"
            class="font-medium text-green-500 border rounded-md p-1 border-green-500 leading-none">
            new
        </div>
        <div
            v-if="hasDriverAlert"
            class="relative">
            <hts-icons
                svg="driver"
                :size="size"
                color="purple" />
        </div>
    </div>
</template>

<script setup lang="ts">
import { isValidWaitingTime } from '@/components/travel-details/-utils/timing'
const props = defineProps({
  params: Object,
  status: Number,
  waiting: Number,
  delay: Number,
  size: String
})
const { params, status, waiting, delay } = toRefs(props)
const data = computed(() => params?.value?.data)

const color = computed(() => {
  let tmp = status?.value
  if (tmp === undefined) {
    tmp = data.value?.processAlertStatus || 0
  }
  if (tmp === undefined) {
    return 'gray'
  }
  if (tmp >= 30) {
    return 'red'
  }
  return 'gray'
})

const { userConfig } = $store()
const authUserId = computed(() => userConfig?.user?.id)
const hasAlert = computed(() => {
  if (!data.value) {
    return false
  }
  if (!authUserId.value) {
    return false
  }
  return data.value[`alertNew.${authUserId.value}`] || false
})

const hasWaiting = computed(() => {
  return isValidWaitingTime(data.value, 'totalWaitingTime')
})
const hasDelay = computed(() => {
  let tmp = delay?.value
  if (tmp === undefined) {
    tmp = data.value?.totalDelayTime || 0
  }
  return !!tmp
})
const hasDriverAlert = computed(() => {
  return !!data.value?.hasDriverAlert
})
</script>
